interface PaywallOverlayProps {
  open: boolean;
  onClose: () => void;
}

export function PaywallOverlay({ open, onClose }: PaywallOverlayProps) {
  if (!open) return null;

  return (
    <div className="overlay" role="dialog" aria-modal aria-labelledby="paywall-title" onClick={onClose}>
      <div className="overlay-card" onClick={(e) => e.stopPropagation()}>
        <h3 id="paywall-title">解锁更多好玩</h3>
        <p>
          专业报告、更多模版和无限次分析，升级后都能用～这里是原型预留，实机会接会员与计费。
        </p>
        <button type="button" className="btn-close" onClick={onClose}>
          好的
        </button>
      </div>
    </div>
  );
}
